import { HeroCol, HeroRow } from "@insightfulscience/atomic-react/Hero/Grid";
import Link from "@insightfulscience/atomic-react/Link";
import Paragraph from "@insightfulscience/atomic-react/Paragraph";
import React from "react";
import Icon from "@insightfulscience/atomic-react/Icon";

const HeroIconSectionOmiq = () => {
	return (
		<HeroRow>
			<HeroCol md={2}>
				<Link href="#getting-started">
					<Icon name="rocket-launch" size="xxxxl" />
					<Paragraph sx={{ fontSize: "xl", fontWeight: "bold" }}>Getting Started</Paragraph>
				</Link>
			</HeroCol>
			<HeroCol md={2}>
				<Link href="#learn-omiq">
					<Icon name="graduation-cap" size="xxxxl" />
					<Paragraph sx={{ fontSize: "xl", fontWeight: "bold" }}>Learn OMIQ</Paragraph>
				</Link>
			</HeroCol>
			<HeroCol md={2}>
				<Link href="https://help.omiq.ai/hc/en-us">
					<Icon name="question" size="xxxxl" />
					<Paragraph sx={{ fontSize: "xl", fontWeight: "bold" }}>FAQ</Paragraph>
				</Link>
			</HeroCol>
			<HeroCol md={2}>
				<Link href="https://help.omiq.ai/hc/en-us/requests/new?ticket_form_id=9319692139540">
					<Icon name="comments-alt" size="xxxxl" />
					<Paragraph sx={{ fontSize: "xl", fontWeight: "bold" }}>Support</Paragraph>
				</Link>
			</HeroCol>
		</HeroRow>
	);
};

export default HeroIconSectionOmiq;
